const store = 'partner';
const terms = [store, 'terms'];
const currentAcademicYear = [store, 'currentAcademicYear'];
const ritQuintiles = [store, 'ritQuintiles'];

export default {
    fullStore: [store],
    terms,
    currentAcademicYear,
    currentTerm: [store, 'currentTerm'],
    futureTermsSetup: [store, 'futureTermsSetup'],
    partnerBid: ['user', 'partnerBid'], // populated by call to user profile service
    ritQuintiles,
    districtAverages: [store, 'districtAverages'],
    linkingStudies: [store, 'linkingStudies'],
};
